import Model from './BaseModel';

export default class ParentMarket extends Model {
	resourceName() {
		return 'parent_markets';
	}

	fields() {
		return ['name', 'market_type', 'order', 'is_manual', 'line'];
	}
}
